import { InventoryResponse } from "@shared/types";
import { css } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

/**
 * Represents the Canvas page
 */
export class InventoryCanvas extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private list: HTMLUListElement;

    public constructor() {
        super();

        const shadow: ShadowRoot = this.attachShadow({ mode: "open" });

        const container: HTMLDivElement = document.createElement("div");
        container.id = "inventory-container";

        const title: HTMLDivElement = document.createElement("div");
        title.id = "inventory-title";
        title.textContent = "Inventory";
        const containerList: HTMLDivElement = document.createElement("div");
        containerList.id = "inventory-list-container";
        containerList.style.display = "none";

        this.list = document.createElement("ul");
        this.list.id = "inventory-list";

        containerList.appendChild(this.list);

        container.appendChild(title);
        container.appendChild(containerList);
        shadow.appendChild(container);

        container.addEventListener("click", () => {
            containerList.style.display = containerList.style.display === "none" ? "block" : "none";
        });

        const styles: HTMLStyleElement = document.createElement("style");
        styles.textContent = css`
            #inventory-container {
                display: flex;
                flex-direction: column;
                z-index: 200;
                position: absolute;
                width: 150px;
                margin: 10px;
                margin-top: 100px;
                margin-left: 20px;
                padding: 20px;
                background-color: #075398;
                color: white;
                font-family: "Onesize", Arial, sans-serif;
                font-size: 18px;
                border-radius: 20px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                cursor: pointer;
            }
            #inventory-title {
                text-align: center;
                font-weight: bold;
            }
            #inventory-list-container {
                border: 1px solid white;
                padding: 10px;
                border-radius: 10px;
                background-color: rgba(255, 255, 255, 0.1);
                display: none;
            }
            #inventory-list {
                list-style-type: none;
                padding: 0;
                margin: 0;
            }
            #inventory-list li {
                padding: 5px 0;
                text-align: center;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            }
            #inventory-list li:last-child {
                border-bottom: none;
            }
        `;

        shadow.appendChild(styles);
        void this.refreshGameState();
        this.observeInventoryChanges();
    }

    private async refreshGameState(): Promise<void> {
        try {
            const response: InventoryResponse | undefined = (await this._gameRouteService.getInventory()) as InventoryResponse | undefined;

            if (!response || !Array.isArray(response.inventory)) {
                this.list.innerHTML = "<li>No items in inventory</li>";
                return;
            }

            this.list.innerHTML = response.inventory.map(item => `<li>${item}</li>`).join("");
        }
        catch (error) {
            console.error("Error fetching inventory:", error);
            this.list.innerHTML = `<li>Error: ${(error as Error).message}</li>`;
        }
    }

    private observeInventoryChanges(): void {
        setInterval(() => this.refreshGameState(), 300);
    }
}
